import { useEffect } from "react";

export const SITE_URL = "https://huntersmapp.com";

const setMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    Object.entries(attrs).forEach(([k, v]) => k !== "content" && k !== "href" && el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

/**
 * Sets document title, description, canonical and Open Graph tags for the current route.
 * Pre-rendering snapshots the DOM after this ran, so crawlers see per-page metadata.
 */
export const usePageMeta = ({ title, description, path = "/", lang = "de", noindex = false }) => {
  useEffect(() => {
    if (!title) return;
    const url = `${SITE_URL}${path === "/" ? "/" : path}`;
    document.title = title;
    setMeta('meta[name="description"]', { name: "description", content: description || "" });
    setMeta('link[rel="canonical"]', { rel: "canonical", href: url });
    setMeta('meta[property="og:title"]', { property: "og:title", content: title });
    setMeta('meta[property="og:description"]', { property: "og:description", content: description || "" });
    setMeta('meta[property="og:url"]', { property: "og:url", content: url });
    setMeta('meta[property="og:locale"]', { property: "og:locale", content: lang === "de" ? "de_DE" : "en_GB" });
    setMeta('meta[name="robots"]', { name: "robots", content: noindex ? "noindex, follow" : "index, follow" });
  }, [title, description, path, lang, noindex]);
};
